import { Row, Col, Layout } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { color } from '../resources';
const { Header, Sider } = Layout;

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'HeaventRoundedLight';
        src: url("../assets/fonts/OTF/DB-HeaventRounded-Light.ttf") format("truetype");
        font-weight: 200;
    }
    @font-face {
        font-family: 'HeaventRoundedBold';
        src: url("../assets/fonts/OTF/DB-HeaventRounded-Bold.ttf") format("truetype");
        font-weight: 600;
    }
    @font-face {
        font-family: 'HeaventRoundedMedium';
        src: url("../assets/fonts/OTF/DB-HeaventRounded-Medium.ttf") format("truetype");
        font-weight: 400;
    }
    html, body {
        height: 100%;
        width: 100%;
        padding: 0;
        margin: 0;
        background: #FAFAFA;
        font-family: HeaventRoundedLight, 'sans-serif' !important;
        color: #444;
        scrollbar-width: thin;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    a {
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      margin-right: 30px;
      font-size:24px;
      color: #646464;
    }
    a:hover,a:active {
      color: #94E1E3;
    }
    .ant-layout .ant-layout-header {
      line-height: 80px;
    }
    span, button{
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
    }
    .ant-radio-button-wrapper{
      font-size: 18px;
    }
    .ant-steps{
      font-family: HeaventRoundedLight, 'sans-serif' !important;
    }
    .ant-steps-item-title{
      color: ${color.white} !important;
      font-size: 20px !important;
    }
    .ant-steps.ant-steps-label-vertical .ant-steps-item-content{
      display: block !important;
      width: 175px !important;
      text-align: center !important;
    }
    .ant-steps-item-tail::after {
      background-color: ${color.white};
    }
    .ant-steps-item-icon {
      width: 80px !important;
      height: 80px !important;
      border-radius: 50% !important;
      background: ${color.white} !important;
    }
    .ant-steps-icon{
      line-height: 75px !important;
    }
    .ant-steps-item-tail{
      margin-inline-start: 107px !important;
      padding: 28px 12px !important;
    }
    .ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
      background-color: ${color.white};
    }
    .ant-steps .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content{
      border-bottom: 3px solid ${color.white} !important;
    }
    .collapse-title{
      font-size: 22px;
      color:#646464;
      margin-right: 20px;
    }
    .collapse-title-help{
      color:${color.theme};
      font-size: 18px;
    }
    .icon-help{
      font-size: 16px;
    }
    .icon-info{
      font-size: 18px;
      margin-right: 8px;
      color: #FB4141;
    }
    .message-info{
      font-size: 18px;
      color: #FB4141;
    }
    .ant-modal-title{
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 28px !important;
      text-align: center !important;
    }
    .ant-modal-header{
      margin-bottom: 20px !important;
      border-bottom: 2px solid #e8e8e8 !important;
    }

    .ant-btn-default:active {
      color: ${color.darkgreen};
      border-color: ${color.darkgreen};
      background-color: ${color.lightgreen} !important;
    }
  .ant-btn-primary{
        color: #4FA1A4;
        border: 1px solid;
        background-color: ${color.lightgreen};

    }
    .space-container {
      display: flex;
      justify-content: space-between;
      width: 100%; /* ตั้งความกว้างของคอนเทนเนอร์ให้เต็มหน้าจอ */
      align-items: center;
      margin-bottom: 12px;
    }

    .text-title {
      text-align: left;
      font-size: 22px;
      color:#8D8D8D;
    }

    .text-detail {
      text-align: right;
      font-size: 22px;
      color:${color.darkgrey};
    }
    .text-title-price {
      text-align: left;
      font-size: 24px;
      color:${color.darkgrey};
    }

    .text-detail-price {
      text-align: right;
      font-size: 40px;
      color:${color.theme};
    }
    .alert-info-red{
      background-color: ${color.lightred};
      color: #FB4141;
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 20px;
      border: 1px;
    }
    .ant-input {
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 20px;

    }
    .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder{
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 20px;
      margin: auto !important;
    }
    .ant-alert-info .ant-alert-icon {
      color: #FB4141;
    }
    .radio-btn{
      width: 49%;
      border-radius: 6px;
      text-align: center;
      font-size: 24px !important;
      height: 100% !important;
      padding: 8px;
      border: 1px solid ${color.theme};
      color: ${color.theme};
    }
    .text-detail-recomend{
      text-align: left;
      font-size: 20px;
      color: #8D8D8D;
      margin-left: 18px;
      }
    .radio-group{
      display: flex;
      justify-content: space-between;
      width: 100%;
      text-align: center;
    }
    .btn-copy{
      padding: 6px 10px;
      height: 40px;
      background-color: ${color.theme};
      color: ${color.white};
    font-size: 20px;
    }

    .ant-radio-button-wrapper:not(:first-child)::before {
      background-color: #d9d9d900;
    }
    .ant-select-dropdown .ant-select-item-option-content{
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size:20px;
    }

    /* เอา border ออกจาก .ant-picker-content */
    .ant-picker-body .ant-picker-content {
      border: none !important;
    }

    /* จัดกึ่งกลางแนวตั้งและแนวนอนใน td (เซลล์ของวันที่) */
    .ant-picker-body .ant-picker-calendar td {
      vertical-align: middle !important;  /* จัดกึ่งกลางแนวตั้ง */
      text-align: center !important;      /* จัดกึ่งกลางแนวนอน */
      border: none !important;           /* เอา border ออก */
    }

    /* ปรับสไตล์ th (หัวตาราง) */
    .ant-picker-calendar .ant-picker-content th {
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 18px !important;
      text-align: center !important;  /* จัดกึ่งกลางข้อความในหัวตาราง */
      border: none !important;        /* เอา border ออก */
    }

    /* จัดกึ่งกลางข้อความใน td (เซลล์ของวันที่) */
    .ant-picker-calendar .ant-picker-content td {
      vertical-align: middle !important;
      text-align: center !important;
      border: none !important;
      padding: 10px !important;
      box-sizing: border-box;
    }

    .ant-picker-panel .ant-picker-month-panel td{
      text-align: center !important;
      padding: 10px !important;
      width: 33.33% !important;
      box-sizing: border-box;
    }

    .ant-picker-calendar-date-value{
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
      font-size: 18px !important;
    }

    .ant-select-selection-item{
      font-size: 18px;
    }

    .ant-picker-calendar .ant-picker-cell .ant-picker-cell-inner{
      min-width: 45px;
      text-align: center !important;
      border: none !important;
    }

    .ant-modal-confirm .ant-modal-confirm-body .ant-modal-confirm-content {
      color: ${color.darkgrey};
      font-size: 18px;
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
    }
    .ant-modal-confirm .ant-modal-confirm-btns .ant-btn+.ant-btn {
      width: 47%;
      background-color: #FCE100;
      height: auto;
      font-size: 20px;
      color: ${color.darkgrey};
      border: 1px solid #FCE100;
    }
    .ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
      width: 47%;
    background-color: #C1C1C1;
    height: auto;
    font-size: 18px;
    color: ${color.white};
    border: 1px solid #C1C1C1;
    }
    .ant-picker .ant-picker-input >input {
      font-size: 22px;
      font-family: HeaventRoundedMedium, 'sans-serif' !important;
    }
    .ant-alert-with-description .ant-alert-description {
      padding-top: 6px !important;
    }
`;

export const RowComponent = styled(Row)`
  display: flex;
  align-items: center;
`;

export const Required = styled.div`
  color: ${color.red};
  position: relative;
  top: 3px;
  left: 3px;
`;

export const ContainerButton = styled(Col)`
  text-align-last: ${(props) =>
    props.left ? 'start' : props.center ? 'center' : props.right ? 'end' : ''};
  width: 100%;
`;

export const HeaderBarStyle = styled(Header)`
  padding: 0 !important;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
`;

export const SideBarStyle = styled(Sider)`
  overflow: auto;
  height: 100vh;
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
`;

export default GlobalStyle;
